const getInvoiceReminderNameFrom = (reminderStepNumber?: number | null) => {
  if(!reminderStepNumber) return "Zahlungserinnerung"
  switch (reminderStepNumber) {
    case 0:
      return "Zahlungserinnerung"
    case 1:
      return "Mahnung"
    case 2:
      return "Letzte Mahnung"
    default:
      return `Mahnung`
  }
  //return reminderStepNumber && reminderStepNumber > 0 ? `${reminderStepNumber}. Mahnung` : `Zahlungserinnerung`
}

export default getInvoiceReminderNameFrom